import {
  BaseControlSettings,
  defaultToolSettings,
} from 'src/features/forms/base/controls/inputs/base/baseControlSettings';
import { UserComponent } from '@craftjs/core';
import { createId } from 'src/helpers/typeUtils';
import { IContainerProps } from '../containers/Container';

export interface IBmiInputV2Props extends BaseControlSettings, IContainerProps {
  dataKey: string;
}

export type IBmiInputV2 = UserComponent<IBmiInputV2Props>;

export function bmiInputV2DefaultPropsFactory(): IBmiInputV2Props {
  return {
    ...defaultToolSettings,
    dataKey: createId(),
  };
}
